import { isGroupSettings } from 'components/Graph/GraphState';
import { setGroupedEdge } from 'components/Graph/commands/setGroupedEdge';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';

export const ungroupStpGroup: GraphCommandFactory =
  (cmdContext, dispatch) => () => {
    const {
      layoutSettings: {
        presetDraft: { edges },
      },
    } = cmdContext.getState();
    const groups = edges.filter(isGroupSettings);
    const stpGroup = groups.find(({ children }) =>
      children.some(({ name }) => name === 'stp'),
    );

    if (stpGroup) {
      dispatch(setGroupedEdge, {
        grouped: false,
        edgeSettingsId: stpGroup.id,
      });
    }
  };
